export const enum CHANNELS_TYPES {
    ZOOM = 'ZOOM',
    YOUTUBE = 'YOUTUBE',
    UTPL_EVENTS = 'UTPL_EVENTS',
    FACEBOOK = 'FACEBOOK',
}
